import "../../../resources/less/Family/ThemePages/ThemesListPage.less";

class ThemesListPage {
  constructor() {}
}

$(window).on("load", () => {
  new ThemesListPage();
});
